import {MasterOfActsAPI} from "../../api/api";

const SUCCESS_LOAD_HANDBOOKS = 'handbookReducer/SUCCESS_LOAD_HANDBOOKS'
const ERROR_LOAD_HANDBOOKS = 'handbookReducer/ERROR_LOAD_HANDBOOKS'
const SET_SELECTED_HANDBOOK = 'handbookReducer/SET_SELECTED_HANDBOOK'


const initialState = {
    handbooks: [],
    selectedHandbook: null,
    loading: true,
    error: null
}

export const handbookReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_LOAD_HANDBOOKS:
            return {...state, handbooks: action.handbooks, loading: false, selectedHandbook: action.handbooks[0]}
        case ERROR_LOAD_HANDBOOKS:
            return {...state, loading: false, error: 'Что-то пошло не так... Попробуйте позже'}
        case SET_SELECTED_HANDBOOK:
            return {...state, selectedHandbook: action.selectedHandbook}
        default:
            return state
    }
}


export const getHandbooks = (state) => state.handbookReducer

export const successLoadHandbooks = (handbooks) => ({type: SUCCESS_LOAD_HANDBOOKS, handbooks})
export const errorLoadHandbooks = () => ({type: ERROR_LOAD_HANDBOOKS})
export const setSelectedHandbook = (selectedHandbook) => ({type: SET_SELECTED_HANDBOOK, selectedHandbook})


export const loadingHandbooks = projectID => async dispatch => {
    const response = await MasterOfActsAPI.getHandbooks(projectID)

    if (response.status === 200) {
        dispatch(successLoadHandbooks(response.data))
    } else {
        dispatch(errorLoadHandbooks())
    }
}

export const loadingHandbook = id => async dispatch => {
    const response = await MasterOfActsAPI.getHandbook(id)

    if (response.status === 200) {
        dispatch(setSelectedHandbook(response.data))
    } else {
        dispatch(errorLoadHandbooks())
    }
}